import { ALL_GROUPS_TABS } from '@communities/groups-layer/utils/constants'

/**
 * Maps a legacy first-segment-after-[groupSlug] to the canonical Vue route name
 * the user should land on. Single source of truth for legacy → canonical group
 * route redirects. Add a new legacy alias here and the global group-access
 * middleware will pick it up automatically.
 *
 * Page-level `definePageMeta.alias` arrays must be kept in sync manually
 * because Nuxt requires those values to be statically resolvable at build time.
 */
export const LEGACY_GROUP_ROUTE_ALIASES: Readonly<Record<string, string>> = {
  'private-group': ALL_GROUPS_TABS.about.route,
  'to-review': 'communities-groups-settings-reported-content',
  'member-list': ALL_GROUPS_TABS.members.route,
  'members-list': ALL_GROUPS_TABS.members.route,
} as const

export type LegacyGroupSegment = keyof typeof LEGACY_GROUP_ROUTE_ALIASES
